<template>
  <div>
    <b-row v-if="field.fieldType == 19">
      <b-col class="mt-0">
        {{ field.text }}
      </b-col>
      <b-col cols="2">
        <a href="#" @click="downloadRoute(field.fieldId, item.id)">
          <i class="tim-icons icon-attach-87 route"> </i>
        </a>
      </b-col>
    </b-row>
    <b-row v-else-if="field.fieldType == 1000">
      <b-col class="mt-0">
        {{ `${itemName}: ` }}
        <a href="#" @click="$refs.checklistDetails.open()" style="color: white">
          # <u>{{ itemValue }}</u>
        </a>
      </b-col>
      <b-col cols="2">
        <a href="#" @click="$refs.checklistDetails.open()" style="color: white">
          <b-icon icon="eye" aria-hidden="true"></b-icon>
        </a>
      </b-col>
      <pendency-field-details-modal ref="checklistDetails" :id="itemValue" />
    </b-row>
    <b-row v-else>
      <b-col class="mt-0">
        {{ field.text }}
      </b-col>
    </b-row>
  </div>
</template>
  
  <script>
export default {
  name: "WorkflowKanbanCardItem",
  components: {
    "pendency-field-details-modal": () =>
      import("@/pagesRms/checklist/pendency/PedencyFieldDetailsModal.vue"),
  },
  props: ["item", "tower", "field"],
  data: function () {
    return {
      urlChecklist: "",
      accessKey: "",
      urlCte: "",
      urlMap: "",
      alert: {
        error: "",
        success: "Registro alterado com sucesso",
      },
    };
  },
  computed: {
    itemName() {
      return this.field.text.split(": ")[0];
    },
    itemValue() {
      return this.field.text.split(": ")[1];
    },
  },
  methods: {
    openNextStage() {
      this.$refs.kanbanEditModal.show();
    },
    refreshData() {
      this.$emit("refreshData");
    },
    downloadRoute(fieldId, processFilledId) {
      this.$apiWorkflow
        .request({
          url: "/path/print/" + fieldId + "/" + processFilledId,
          method: "POST",
          responseType: "arraybuffer", //important
        })
        .then((response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
  },
};
</script>
  
  
  <style>
.pre-formatted {
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
}
.route {
  color: white !important;
}
</style>